<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="users"
      :sort-by="[{ key: 'name', order: 'asc' }]"
      class="elevation-1"
      :search="search"
    >
      <!-- eslint-disable -->
      <template v-slot:item="{ item }">
        <tr
          :class="{ 'lower-opacity': !(item.value || item.selectable)?.ativo }"
        >
          <td>
            <!-- Para testar os valores -->
            <!-- <span>{{ item.value || item.selectable }}</span> -->
            <template
              v-if="(item.value || item.selectable)?.autenticado !== false"
            >
              <v-avatar size="40">
                <img
                  style="width: 100%"
                  :src="(item.value || item.selectable)?.imgPath"
                />
              </v-avatar>
            </template>
            <template v-else>
              <v-avatar size="40">
                <v-img :src="UserImage"></v-img>
              </v-avatar>
            </template>
          </td>
          <td>{{ (item.value || item.selectable)?.name }}</td>
          <td>{{ (item.value || item.selectable)?.email }}</td>
          <td>{{ (item.value || item.selectable)?.userGit }}</td>
          <td>{{ (item.value || item.selectable)?.situacao }}</td>
          <td>
            <v-tooltip text="Visualizar usuário" location="bottom">
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="small"
                  class="me-2"
                  @click="showItem(item.raw)"
                >
                  mdi-eye
                </v-icon>
              </template>
            </v-tooltip>
            <v-tooltip
              text="Desabilitar usuário"
              location="bottom"
              v-if="item.raw.ativo"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="small"
                  class="me-2"
                  @click="modalDesabilitar(item.raw)"
                >
                  mdi-account-off
                </v-icon>
              </template>
            </v-tooltip>
            <v-tooltip text="Reativar usuário" location="bottom" v-else>
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="small"
                  class="me-2"
                  @click="modalReativar(item.raw)"
                >
                  mdi-account-reactivate
                </v-icon>
              </template>
            </v-tooltip>
            <v-tooltip text="Excluir usuário" location="bottom">
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="small"
                  color="red"
                  @click="modalExcluir(item.raw)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-tooltip>
          </td>
          <!-- Outras colunas da tabela -->
        </tr>
      </template>

      <!-- eslint-enable -->

      <template #top>
        <v-toolbar flat>
          <v-toolbar-title style="font-size: 22px; font-weight: bold"
            >Usuários</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="flex">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              outline
              hide-details
              variant="underlined"
              style="width: 40%"
            ></v-text-field>
            <ModalConvidarUsuario style="margin-right: 40px" />
          </div>

          <!-- Desabilitar usuário -->
          <v-dialog v-model="showConfirmationModalDesabilitar" width="620px">
            <v-card>
              <v-card-title>
                <span>Desabilitar usuário</span>
              </v-card-title>
              <v-card-text>
                <p>
                  Tem certeza de que deseja desabilitar o usuário(a)
                  <strong>{{ this.nomeUsuario }}</strong> do sistema?
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red"
                  text
                  @click="showConfirmationModalDesabilitar = false"
                >
                  Cancelar
                </v-btn>
                <v-btn color="#004984" text @click="desabilitarUsuario">
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Reativar usuário -->
          <v-dialog v-model="showConfirmationModalReativar" width="620px">
            <v-card>
              <v-card-title>
                <span>Reativar usuário</span>
              </v-card-title>
              <v-card-text>
                <p>
                  Tem certeza de que deseja reativar o usuário(a)
                  <strong>{{ this.nomeUsuario }}</strong> no sistema?
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red"
                  text
                  @click="showConfirmationModalReativar = false"
                >
                  Cancelar
                </v-btn>
                <v-btn color="#004984" text @click="reativarUsuario">
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Ver usuário -->
          <v-dialog v-model="dialogView" max-width="850px">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="8">
                      <v-label>Nome</v-label>
                      <p>{{ editedItem.name }}</p>
                    </v-col>
                    <v-col cols="12" sm="8" md="4">
                      <v-label>Usuário do Git</v-label>
                      <p>{{ editedItem.userGit }}</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="8">
                      <v-label>Email</v-label>
                      <p>{{ editedItem.email }}</p>
                    </v-col>
                    <v-col cols="12" sm="8" md="4">
                      <v-label>Situação</v-label>
                      <p>{{ editedItem.situacao }}</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-label>Equipes</v-label>
                      <v-list
                        class="d-flex flex-wrap"
                        :min-width="150"
                        lines="one"
                        v-if="editedItem.equipes.length > 0"
                      >
                        <!-- eslint-disable -->
                        <v-list-item
                          v-for="equipe in editedItem.equipes"
                          :key="equipe.nomeEquipe"
                          :title="
                            equipe.nomeEquipe + ` - ${equipe.formaAtuacao}`
                          "
                          elevation="2"
                          class="equipe-item"
                        >
                          <template v-if="equipe.projetos.length > 0">
                            <v-list-item-subtitle
                              >Projetos:</v-list-item-subtitle
                            >
                            <v-list-item-group>
                              <v-list-item
                                v-for="projeto in equipe.projetos"
                                :key="projeto.id_projeto"
                                :subtitle="projeto.nome"
                              ></v-list-item>
                            </v-list-item-group>
                          </template>
                        </v-list-item>
                        <!-- eslint-enable -->
                      </v-list>
                      <p v-else>Sem equipes</p>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedItem.autenticado">
                    <v-col cols="12" class="mt-4 text-center">
                      <!-- eslint-disable -->
                      <v-avatar size="45">
                        <v-img alt="Avatar" :src="editedItem.imgPath"></v-img>
                      </v-avatar>
                      <!-- eslint-enable -->
                      <p
                        style="
                          display: inline-block;
                          margin-left: 10px;
                          color: gray;
                        "
                      >
                        Usuário(a) autenticado com GitHub.
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- Remover usuário -->
          <v-dialog v-model="showConfirmationModalExcluir" width="620px">
            <v-card>
              <v-card-title>
                <span>Excluir usuário</span>
              </v-card-title>
              <v-card-text>
                <p>
                  Este usuário só pode ser removido se não fizer parte de nenhum
                  <strong>projeto ou equipe</strong>. Deseja realmente excluir
                  <strong>{{ this.nomeUsuario }}</strong> do sistema?
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red"
                  text
                  @click="showConfirmationModalExcluir = false"
                >
                  Cancelar
                </v-btn>
                <v-btn color="#004984" text @click="excluirUsuario">
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template #no-data>
        <div class="text-center py-6">
          <span> Sem usuários a listar </span>
        </div>
      </template>
      <!-- <template v-slot:bottom>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import UserImage from '@/assets/img/img_padrao.jpg';
import ModalConvidarUsuario from '@/components/dialogs/ModalConvidarUsuario.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    ModalConvidarUsuario,
    SnackBar,
  },
  data: () => ({
    dialogView: false,
    headers: [
      {
        title: '',
        key: 'imgPath',
        sortable: false,
      },
      {
        title: 'Nome',
        align: 'start',
        key: 'name',
      },
      { title: 'Email', key: 'email' },
      { title: 'Usuário GitHub', key: 'userGit' },
      { title: 'Situação', key: 'funcao' },
      { title: 'Ações', key: 'actions', sortable: false },
    ],
    users: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      email: '',
      userGit: '',
      funcao: '',
      autenticado: '',
      imgPath: '',
      situacao: '',
      equipes: [],
    },

    UserImage: UserImage,
    showConfirmationModalDesabilitar: false,
    showConfirmationModalExcluir: false,
    showConfirmationModalReativar: false,
    idUsuario: null,
    nomeUsuario: undefined,
    search: '',
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Convidar Usuário' : 'Editar usuário';
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.fetchUsers();
  },

  methods: {
    /* eslint-disable */
    /**
     * Busca usuários na API e atualiza a lista de usuários com as informações recebidas.
     * @function
     * @name fetchUsers
     * @returns {void}
     * @throws {Error} Se ocorrer um erro na chamada da API.
     */
    /* eslint-enable */
    fetchUsers() {
      axios
        .get(API_URL + '/usuarios', {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.users = response.data.map((element) => {
            /* eslint-disable */
            element.fl_coordenador === true
              ? (element.fl_coordenador = 'Coordenador')
              : (element.fl_coordenador = 'Desenvolvedor');
            element.access_token_git != null
              ? (element.access_token_git = true)
              : (element.access_token_git = false);

            let situacao = '';
            if (element.fl_coordenador === 'Coordenador') {
              if (element.fl_ativo) {
                // COORDENADOR e ATIVO
                situacao = 'Coordenador';
              } else {
                // COORDENADOR e DESABILITADO
                situacao = 'Desabilitado';
              }
            } else {
              // NAO É COORDENADOR
              if (!element.fl_ativo) {
                // NÃO TA ATIVO
                situacao = 'Desabilitado';
              } else {
                // ESTÁ ATIVO E NÃO É COORDENADOR
                const temEquipeComProjeto = element.tb_membro.some(
                  (equipe) => equipe.tb_equipe.tb_projeto.length > 0
                );
                situacao = temEquipeComProjeto
                  ? 'Membro de projeto'
                  : 'Sem projeto';
              }
            }
            /* eslint-enable */

            const equipes = element.tb_membro.map((equipe) => ({
              nomeEquipe: equipe.tb_equipe.nome_equipe,
              projetos: equipe.tb_equipe.tb_projeto.map((projeto) => ({
                nome: projeto.nome,
                descricao: projeto.descricao,
                sigla: projeto.sigla,
              })),
              formaAtuacao: equipe.forma_atuacao,
            }));

            return {
              name: element.nome,
              email: element.email,
              userGit: element.usuario_git,
              funcao: element.fl_coordenador,
              autenticado: element.access_token_git,
              imgPath: element.img_url,
              idUsuario: element.id_usuario,
              ativo: element.fl_ativo,
              situacao: situacao,
              equipes: equipes,
            };
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },

    /**
     * Mostra o item selecionado em um dialog
     *
     * @param {Object} item - O item selecionado
     * @returns {void}
     */
    showItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogView = true;
      // console.log(item);
    },
    modalDesabilitar(item) {
      // console.log(item.idUsuario);
      this.idUsuario = item.idUsuario;
      this.nomeUsuario = item.name;
      this.showConfirmationModalDesabilitar = true;
    },
    modalExcluir(item) {
      // console.log(item.idUsuario);
      this.idUsuario = item.idUsuario;
      this.nomeUsuario = item.name;
      this.showConfirmationModalExcluir = true;
    },
    modalReativar(item) {
      // console.log(item.idUsuario);
      this.idUsuario = item.idUsuario;
      this.nomeUsuario = item.name;
      this.showConfirmationModalReativar = true;
    },
    desabilitarUsuario() {
      axios
        .put(
          API_URL + `/usuarios/${this.idUsuario}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        )
        .then((response) => {
          console.log(response);
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Usuário desabilitado com sucesso!',
          );
          this.showConfirmationModalDesabilitar = false;
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((error) => {
          console.error(error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos desabilitar este usuário!',
          );
          this.showConfirmationModalDesabilitar = false;
        });
    },
    reativarUsuario() {
      axios
        .patch(
          API_URL + `/usuarios/${this.idUsuario}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        )
        .then((response) => {
          console.log(response);
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Usuário reativado com sucesso!',
          );
          this.showConfirmationModalReativar = false;
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((error) => {
          console.error(error.response.data.error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            `${error.response.data.error}`,
          );
          this.showConfirmationModalReativar = false;
        });
    },
    // Deletar usuario, posteriormente uma função do back
    /**
     * Deleta um item.
     * @param {Object} item - O item a ser deletado.
     * @return {void}
     */
    excluirUsuario() {
      axios
        .delete(API_URL + `/usuarios/${this.idUsuario}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Usuário excluído com sucesso!',
          );
          this.showConfirmationModalExcluir = false;
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((error) => {
          console.error(error);
          if (error.response.status === 400) {
            this.$refs.snackbar.showWarningSnackbar(
              'Informação',
              error.response.data.message,
            );
          } else {
            this.$refs.snackbar.showErrorSnackbar(
              'Hm... Algo deu errado',
              'Por algum motivo, não conseguimos excluir este usuáraio!',
            );
          }

          this.showConfirmationModalExcluir = false;
        });
    },
    /* eslint-disable */
    /**
     * Fecha o diálogo de edição/criação de usuário, resetando os campos editados.
     */
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        /**
         * Item em edição/criação que foi editado. É resetado para o objeto padrão.
         * @type {Object}
         */
        this.editedItem = Object.assign({}, this.defaultItem);
        /**
         * Índice do item em edição/criação que foi editado. É resetado para -1.
         * @type {Number}
         */
        this.editedIndex = -1;
      });
    },
  },
};
</script>

<style scoped>
.disabled-user {
  opacity: 40% !important;
}
.flex {
  display: flex;
  width: 50%;
  align-items: center;
}
.flex-wrap {
  flex-wrap: wrap;
}
.d-flex {
  display: flex;
  padding: 0;
}
.equipe-item {
  width: 98%;
  padding: 10px;
  margin: 10px 5px;
}
.lower-opacity td:not(:last-child) {
  opacity: 0.4;
}
</style>
